/**
 * MT標準のウィジェットのHTMLを作成します。
 *
 * Updated: 2023/09/30
 *
 * 使用例:
 * ```
 * const contentHtml = `
 *    <p>mtapp.makeWidget()で作成したウィジェットです。</p>
 *    <div class="row">
 *     <div class="col">
 *       <button type="button" class="btn btn-primary mx-1">ボタン1</button>
 *       <button type="button" class="btn btn-default mx-1">ボタン2</button>
 *     </div>
 *   </div>
 *   `;
 * const html = mtapp.makeWidget({
 *     basename: 'exampleWidgetId',
 *     label: 'ウィジェットタイトル',
 *     content: contentHtml,
 *     footer: '<div>フッター部分の情報。</div>'
 * });
 * document.querySelector('#content-data-status-widget').insertAdjacentHTML('afterend', html);
 * ```
 *
 * @param {Object} options
 * @param {String} options.basename ウィジェットのID。
 * @param {String} options.label ラベル部分のテキスト、HTML
 * @param {String} options.content コンテンツ部分のテキスト、HTML
 * @returns {string} ウィジェットのHTML
 */
import { temporaryId } from './temporaryId.js';
export function makeWidget(options) {
    const defaultOptions = {
        basename: '',
        label: '',
        content: ''
    };

    const op = { ...defaultOptions, ...options };

    const id = op.basename || temporaryId();

    return `
        <div id="${id}-field" class="mt-widget">
            <h2 class="mt-widget__title">${op.label}</h2>
            <div class="mt-widget__content">${op.content}</div>
        </div>
    `;
}
